import { useEffect, useState } from "react";
import { CompanySettingsDesktopView } from "./companySettingsDesktopView/companySettingsDesktopView.component";
import { CompanySettingsMobileView } from "./companySettingsMobileView/companySettingsMobileView.component";
import { CompanySystemSettings } from "./companySettingsMobileView/companySystemSettings/companySystemSettings.component";
import { CompanySubscription } from "./companySubscription/companySubscription.component";
import { CompanyTipPayout } from "./companyTipPayout/companyTipPayout";
import { CompanyUsers } from "./companyUsers/companyUsers.component";
import { DetailsSettings } from "./detailsSettings/detailsSettings.component";
import { ObSettings } from "./ObSettings/obSettings.component";
import { ProfileSettings } from "./profileSettings/profileSettings.component";
import { CustomerSettings } from "./customerSettings/customerSettings.component";

export const CompanySettings = () => {
  const params = new URLSearchParams(window.location.search);
  const slide = params.get("page");
  const [page, setPage] = useState(0);
  const [view, setView] = useState<string>();

  const getSlide = () => {
    switch (slide) {
      case "profile":
        return <ProfileSettings view={view} />;
      case "details":
        return <DetailsSettings view={view} />;
      case "users":
        return <CompanyUsers view={view} />;
      case "Ob":
        return <ObSettings view={view} />;
      case "Subscription":
        return <CompanySubscription />;
      case "Tip":
        return <CompanyTipPayout />;
      case "Customers":
        return <CustomerSettings />;
      case "System":
        return <CompanySystemSettings />;
      default:
        if (view === "desktop") {
          return <ProfileSettings view={view} />;
        } else {
          return <></>;
        }
    }
  };

  const checkViewWidth = () => {
    if (window.innerWidth >= 768) {
      setView("desktop");
    } else {
      setView("mobile");
    }
  };

  useEffect(() => {
    checkViewWidth();

    window.addEventListener("resize", checkViewWidth);

    return () => {
      window.removeEventListener("resize", checkViewWidth);
    };
  }, []);

  useEffect(() => {
    if (slide) {
      setPage(1);
    } else {
      setPage(0);
    }
  }, [slide]);

  return (
    <>
      {view === "mobile" ? (
        <CompanySettingsMobileView page={page} setPage={setPage} slide={slide}>
          {getSlide()}
        </CompanySettingsMobileView>
      ) : (
        <CompanySettingsDesktopView setPage={setPage}>
          {getSlide()}
        </CompanySettingsDesktopView>
      )}
    </>
  );
};
